{
	"backToManageDeclarations": "Επιστροφή στη Διαχείριση δηλώσεων",
	"kpi": {
		"quantity": "Ποσότητα",
		"carbonSavings": "Μειώσεις άνθρακα"
	},
	"downloadAllDeclarations": "Κατεβάστε όλες τις δηλώσεις",
	"errors": {
		"notFound": "Το έργο δεν βρέθηκε"
	}
}
